import { CaseStudyLayout } from "../components/CaseStudyLayout";

const SECTIONS = [
  {
    title: "The problem and motivation",
    testid: "awg-cs-problem",
    body: [
      "An experimental engineering project exploring atmospheric water collection through condensation — investigating how cooling technology and heat transfer can condense moisture from humid air and collect the resulting water.",
    ],
  },
  {
    title: "The working principle",
    testid: "awg-cs-principle",
    body: [
      "A Peltier thermoelectric module creates a temperature difference between its two faces. Its cold side can cool a surface below the air’s dew point — the temperature at which water vapor in the air begins to condense.",
      "As humid air passes over the cooled surface, water vapor condenses into droplets, which are then collected.",
    ],
    list: [
      "Humid air passes over a cooled surface",
      "A Peltier module cools the surface below the dew point",
      "Water vapor condenses into droplets",
      "Condensate is collected below",
    ],
  },
  {
    title: "Components and materials",
    testid: "awg-cs-components",
    body: ["The experiment explores a small set of core elements:"],
    list: [
      "Peltier thermoelectric module — the cooling element",
      "Heat dissipation — heatsinking and thermal management on the hot side",
      "Condensation surface — where moisture from the air collects",
      "Collection path — guiding condensate into a container",
    ],
  },
  {
    title: "Construction and experimentation",
    testid: "awg-cs-construction",
    placeholder: "how the device was assembled and the experiments run with it",
  },
  {
    title: "Challenges encountered",
    testid: "awg-cs-challenges",
    placeholder: "the practical problems that came up — thermal, electrical, and mechanical",
  },
  {
    title: "Measurements and results",
    testid: "awg-cs-results",
    placeholder: "measured observations — no results published yet; added only after testing",
  },
  {
    title: "Future improvements",
    testid: "awg-cs-future",
    placeholder: "efficiency, energy consumption, and design iterations to explore next",
  },
];

const CaseStudyAWG = () => (
  <CaseStudyLayout
    testid="case-study-awg"
    number="02"
    category="Hardware · Engineering · Sustainability"
    title="Atmospheric Water Generator"
    headline="Exploring how water can be collected from the air."
    intro="A hands-on engineering experiment in condensation, thermoelectric cooling, and heat transfer — applying engineering principles to a real-world challenge."
    sections={SECTIONS}
  />
);

export default CaseStudyAWG;
